import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';

// 定义平台选项配置
const PLATFORM_OPTIONS = [
    // {
    //   value: 'twitch',
    //   label: 'Twitch',
    //   icon: 'fa fa-twitch fa-3x'
    // },
    {
        value: 'youtube',
        label: 'YouTube',
        icon: <svg className='platform-icon2' viewBox="0 0 24 24" fill='#000'><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path></svg>
    }
    // {
    //   value: 'facebook',
    //   label: 'Facebook',
    //   icon: 'fa fa-facebook fa-3x'
    // }
];
// 创建平台选择组件
const PlatformSelector = ({ input, meta: { touched, error } }) => {
    return (
        <div className="platform-container">
            <label>Select Platform</label>
            <div className="platform-selector">
                {PLATFORM_OPTIONS.map(platform => (
                    <button
                        key={platform.value}
                        type="button"
                        className={`platform-button ${input.value === platform.value ? 'active' : ''}`}
                        data-platform=""
                        onClick={() => input.onChange(platform.value)}
                    >
                        {platform.icon}
                        {platform.label}
                    </button>
                ))}
                {touched && error && <span className="error">{error}</span>}
            </div>
        </div>
    );
};
const MultiVideoSubmissionFields = ({ step }) => {
    return (
        <>
            <div className="input-container" style={{ width: '75%', marginLeft: '25%' }}>
                <Field
                    name={`${step}.selectPlatform`}
                    id={`${step}.selectPlatform`}
                    component={PlatformSelector}
                    label="Select Platform"
                    placeholder="Select Platform"
                    customLabel="Select Platform"
                />
            </div>
            <div className="input-container" style={{ width: '75%', marginLeft: '25%' }}>
                <Field
                    name={`${step}.submittableVideoCount`}
                    id={`${step}.submittableVideoCount`}
                    type="text"
                    component={CustomInput}
                    label="Submittable Video Count"
                    placeholder="Submittable Video Count"
                    customLabel="Submittable Video Count"
                />
            </div>
            <div className="Step__row" style={{ width: '75%', marginLeft: '25%' }}>
                <div className="input-container" style={{ width: '45%' }}>
                    <Field
                        name={`${step}.label`}
                        id={`${step}.label`}
                        type="text"
                        component={CustomInput}
                        label="Label"
                        placeholder="Label"
                        customLabel="Label"
                    />
                </div>
                <div className="input-container" style={{ width: '45%' }}>
                    <Field
                        name={`${step}.placeholder`}
                        id={`${step}.placeholder`}
                        type="text"
                        component={CustomInput}
                        label="Placeholder"
                        placeholder="Placeholder"
                        customLabel="Placeholder"
                    />
                </div>
            </div>
        </>
    );
};

MultiVideoSubmissionFields.propTypes = {
    step: PropTypes.string.isRequired
};

export default MultiVideoSubmissionFields;